<template>
  <li v-if="canTransfer" class="context__menu-item">
    <a
      role="button"
      tabindex="0"
      class="context__menu-item-link js-ctx-transfer-row"
      @click="open"
      @keydown.enter.prevent="open"
      @keydown.space.prevent="open"
    >
      <i class="context__menu-item-icon iconoir-arrow-right"></i>
      {{ $t('transferRow.title') }}
    </a>
    <TransferRowModal
      v-if="transferRow"
      ref="modal"
      :database="database"
      :table="table"
      :row="transferRow"
    />
  </li>
</template>

<script>
import TransferRowModal from '@baserow/modules/database/components/row/TransferRowModal'

export default {
  name: 'TransferRowContextItem',
  components: { TransferRowModal },
  props: {
    database: { type: Object, required: true },
    table: { type: Object, required: true },
    row: { type: Object, default: null },
    readOnly: { type: Boolean, default: false },
  },
  emits: ['close-context'],
  data() {
    return { transferRow: null }
  },
  computed: {
    canTransfer() {
      return (
        !this.readOnly &&
        !!this.row?.id &&
        !this.row._?.loading &&
        (!this.table.data_sync || this.table.data_sync.two_way_sync) &&
        this.$hasPermission(
          'database.table.delete_row',
          this.table,
          this.database.workspace.id
        )
      )
    },
  },
  methods: {
    async open() {
      if (!this.canTransfer) return
      this.transferRow = { id: this.row.id }
      this.$emit('close-context')
      await this.$nextTick()
      this.$refs.modal?.show()
    },
  },
}
</script>
